{
  "name": "holo-booth-02",
  "version": "0.10.3",
  "scripts": {
    "test": "echo \"Error: no test specified\" && exit 1",
    "d": "parcel src/index.html --https --host localhost",
    "build": "parcel build src/index.js --dist-dir build",
    "b": "yarn remove-zip & yarn build && yarn zip",
    "remove-zip": "rm *.zip",
    "zip": "zip -r build.zip build && rm -r build",
    "build:prod": "parcel build src/index.html --dist-dir ./build"
  },
  "browserslist": [
    "last 2 ChromeAndroid versions",
    "last 2 iOS major versions"
  ],
  "keywords": [],
  "author": "HYPERVSN",
  "license": "ISC",
  "description": "",
  "packageManager": "yarn@4.9.2",
  "dependencies": {
    "@emotion/react": "^11.14.0",
    "@rive-app/react-canvas": "^4.24.0",
    "motion": "^12.23.24",
    "react": "^19.2.0",
    "react-dom": "^19.2.0",
    "react-router": "^7.9.5",
    "react-router-dom": "^7.9.5"
  },
  "devDependencies": {
    "@babel/core": "^7.28.5",
    "@emotion/babel-plugin": "^11.13.5",
    "@parcel/transformer-svg-jsx": "^2.16.1",
    "parcel": "^2.16.1"
  },
  "alias": {
    "process": false
  }
}
